module.exports = __webpack_public_path__ + "img/shiroshica-pro.edaf8e01.jpg";